import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export function PublicSignerSummaryItem({
  label,
  value
}: {
  label: string;
  value: ReactNode;
}) {
  return (
    <Stack spacing={0} sx={{ minWidth: 0 }}>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Typography
          color="text.primary"
          noWrap
          sx={{
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '20px',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
          variant="body2"
        >
          {value}
        </Typography>
      ) : (
        <Box
          component="div"
          sx={{
            alignItems: 'center',
            display: 'inline-flex',
            minHeight: 20,
            minWidth: 0
          }}
        >
          {value}
        </Box>
      )}
      <Typography
        color="text.secondary"
        noWrap
        sx={{
          fontSize: 12,
          lineHeight: '18px',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
        variant="body2"
      >
        {label}
      </Typography>
    </Stack>
  );
}
